// extracted by mini-css-extract-plugin
export default {"Label":"Label_Label__yXZQY","Error":"Label_Error__LScjQ"};